import { motion, useSpring, useTransform } from 'framer-motion';
import { useEffect, useState } from 'react';

interface AnimateNumberProps {
  value: number;
}

export function AnimatedNumber({ value }: AnimateNumberProps) {
  const spring = useSpring(value, { mass: 0.8, stiffness: 75, damping: 15 });
  const tempDisplay = useTransform(spring, current =>
    Math.round(current).toLocaleString()
  );

  const [display, setDisplay] = useState(tempDisplay.get());

  useEffect(() => {
    return tempDisplay.onChange(v => setDisplay(v));
  }, [tempDisplay]);

  useEffect(() => {
    spring.set(value);
  }, [spring, value]);

  return <motion.span className="tracking-tighter">{display}</motion.span>;
}
